import styled from "@emotion/styled";
import Icon from "./icon";
import { Colors } from "theme/colors";

export const StyledInfo = styled.div`
  position: relative;
  margin-bottom: 1rem;
  padding-left: 2rem;
  line-height: 1.25rem;
`;

export const StyledIcon = styled(Icon)`
  color: ${Colors.RED};
  position: absolute;
  left: 0;
  top: 0;
`;
